import React from 'react';
const CustomSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M10.0069 4.34559L7.65393 1.99265M10.0069 4.34559L7.06658 7.28582C6.67911 7.67329 6.20882 7.97918 5.66887 8.07229C5.1237 8.16635 4.44713 8.19765 4.12449 7.875C3.80185 7.55235 3.83314 6.87577 3.92717 6.33059C4.02029 5.79065 4.3262 5.32035 4.71364 4.93288L7.65393 1.99265M10.0069 4.34559C10.0069 4.34559 11.7715 2.58088 10.5951 1.40441C9.41858 0.227941 7.65393 1.99265 7.65393 1.99265M10.9219 6C10.9219 9.82353 9.7454 11 5.92188 11C2.09835 11 0.921875 9.82353 0.921875 6C0.921875 2.17647 2.09835 1 5.92188 1"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CustomSVG;
